import React from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import { useSquare } from '../hooks';
import CancellationTokenStore from '../../../../../../../../../../services/tokens';
import Square from '../../../../../../../../../../utilities/squareWebSDK';
import "./style.css";
import SquareTestNumbers from './SquareTestNumbers';
import Stack from '@mui/material/Stack';
import NotificationBar from './NotificationBar';
import Alert from '@mui/material/Alert';

const SquareCardElement: React.FC = () => {
    const { bookingCardSecured, formLoaded, squareResetEnabled, error, processing } = useSquare();

    React.useEffect(() => {
        const cancellationTokenStore = new CancellationTokenStore();
        const cancelToken = cancellationTokenStore.generateToken();
        if (!bookingCardSecured) {
            Square.fetchSquare()
        }
        else {
            Square.cleanUp()
        }

        return () => {
            Square.cleanUp()
            cancelToken.cancel();
        }
    }, [bookingCardSecured])

    return (
        (<Paper elevation={2} sx={{ padding: 2, paddingRight: 1 }}>
            <Grid container spacing={2} >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Paper elevation={2} sx={{ padding: 2, paddingRight: "90px", marginLeft: -1 }}>
                        <div id="form-container" style={{
                            width: 485,
                            height: 100,
                            marginLeft: "-10px",
                        }}>
                        </div>
                        <Stack gap={2} direction="row" sx={{ position: "relative", float: "right", right: "-75px", bottom: "35px", marginBottom: "-40px", height: "35px" }}>
                            {!formLoaded && <Alert sx={{ width: 285, alignItems: "center", height: 35 }} severity="info" >Loading Square gateway...</Alert>}
                            <Button id="pay-btn"
                                disabled={(!formLoaded || error || processing) ? true : false}
                                color="primary"
                                variant="contained"
                                onClick={() => Square.tokenize()}>STORE
                            </Button>
                            <Button id="reset-btn"
                                disabled={(!formLoaded || !squareResetEnabled || !error) ? true : false}
                                color="secondary"
                                variant="contained"
                                onClick={() => Square.retry()}>RESET
                            </Button>
                        </Stack>
                    </Paper>
                </Grid>
                <NotificationBar />
                <SquareTestNumbers webSDK={true} />
            </Grid>
        </Paper >)
    );
}

export default React.memo(SquareCardElement)